import { useGetMe } from 'Shared/hooks/api';
import { Analytics } from 'Shared/utils/client';
import { Row, Typography } from '@viewup/ui';
import { EmptyViewingMoneyModal } from 'app/_components/EmptyViewingMoneyModal';
import { useGlobalModalStore } from 'app/_hook';
import { useRouter } from 'next/navigation';
import { menuList } from './AccountMenus.const';

export const AccountMenus = () => {
  const router = useRouter();
  const { data } = useGetMe({ options: { enabled: true } });
  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');
  return (
    <Row
      bgColor='system.white'
      css={{ gridTemplateColumns: 'repeat(2, 1fr)' }}
      display='grid'
      gap={16}
      p={16}
    >
      {menuList.map((list) => (
        <Row
          alignItems='center'
          css={{ cursor: 'pointer' }}
          gap={4}
          key={list.text}
          onClick={() => {
            Analytics.getInstance().track('MY_VIEWUP_ACCOUNT_MENU', {
              type: list.type,
            });

            if (list.type === 'viewing-money') {
              EmptyViewingMoneyModal(data?.data.totalPoint || 0, router, setAlertModal);
            }
            router.push(list.url);
          }}
          p={12}
        >
          {list.icon}
          <Typography color='text.interactive.secondary'>{list.text}</Typography>
        </Row>
      ))}
    </Row>
  );
};
